import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { RelatorioProdutividade } from '../../types/indicadores';
import { relatoriosProdutividadeService } from '../../services';

const fields: ResourceField<RelatorioProdutividade>[] = [
  { name: 'periodo_inicio', label: 'Período inicial', type: 'date' },
  { name: 'periodo_fim', label: 'Período final', type: 'date' },
  { name: 'setor', label: 'Setor', type: 'select', options: [{ label: 'Produção', value: 'PRODUCAO' }, { label: 'Qualidade', value: 'QUALIDADE' }, { label: 'Estoque', value: 'ESTOQUE' }, { label: 'Manutenção', value: 'MANUTENCAO' }, { label: 'Geral', value: 'GERAL' }] },
  { name: 'gerado_por', label: 'Gerado por' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' }
];

export const RelatoriosProdutividadeFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo relatório de produtividade"
    description="Gere um relatório consolidado por setor."
    fields={fields}
    service={ relatoriosProdutividadeService }
    redirectPath="/admin/indicadores/relatorios-produtividade"
    cancelPath="/admin/indicadores/relatorios-produtividade"
  />
);
